<template>
    <v-container column v-if="listingDetails" class="fill-height">
      <v-container>
        <v-banner two-line >
          <template  v-if="listingDetails.headerImages.length !== 0">
            <v-carousel
                v-if="listingDetails.headerImages.length !== 0"
                cycle
                height="350"
                hide-delimiters
                show-arrows-on-hover
                class="hidden-sm-and-down"
            >
              <v-carousel-item
                  v-for="img in listingDetails.headerImages"
                  :key="img.id"
                  @click="openHeaderImage(img)"
              >
                <v-img
                    :src="img.url"
                    height="350px"

                ></v-img>
              </v-carousel-item>
            </v-carousel>
            <v-carousel
                v-if="listingDetails.headerImages.length !== 0"
                cycle
                height="200"
                hide-delimiters
                show-arrows-on-hover
                class="hidden-md-and-up"
            >
              <v-carousel-item
                  v-for="img in listingDetails.headerImages"
                  :key="img.id"
                  @click="openHeaderImage(img)"
              >
                <v-img
                    :src="img.url"
                    contain
                    height="200px"
                ></v-img>
              </v-carousel-item>
            </v-carousel>
          </template>
        </v-banner>
      </v-container>
      <v-container align-center justify-center>
<!--        <v-layout  align-center justify-center>-->
          <!--      items list-->
          <v-layout  class="mt-3" row wrap v-if="items.length !== 0">
            <!--        auto image recognitions-->
            <!--        <v-flex-->
            <!--            v-if="listingDetails"-->
            <!--            xs12 sm4 md4 class="mt-4 ">-->
            <!--          <v-card-->
            <!--              elevation="0"-->
            <!--              class="mx-auto mt-3"-->
            <!--              max-width="344"-->
            <!--              v-if="listingDetails.imgRecogEnabled"-->
            <!--              @click=" routeToImgRecog()">-->
            <!--            <v-img-->
            <!--                src="https://firebasestorage.googleapis.com/v0/b/flexline-app.appspot.com/o/Logo%2FAuto%20Capture.gif?alt=media&token=2ebcdfd0-f0df-48e8-a702-d2cf594e1195"-->
            <!--                height="300px"-->
            <!--                contain-->
            <!--            ></v-img>-->
            <!--            <v-layout align-center  class="subtitle-2 font-weight-light">-->
            <!--              <div class="headline pl-3">Instant Quote</div>-->
            <!--            </v-layout>-->
            <!--          </v-card>-->
            <!--        </v-flex>-->
            <!--              items-->
            <v-flex
                xs12 sm4 md4
                class="mt-4"
                v-for="item in items" :key="item.id">
              <v-card
                  elevation="0"
                  class="mx-auto mt-3"
                  max-width="344"
                  @click=" routeToItem(item)">
                <v-carousel
                    height="300"
                    cycle
                    hide-delimiters
                    show-arrows-on-hover
                    v-if="item.imgs.length !== 0"
                >
                  <v-carousel-item
                      v-for="img in item.imgs"
                      :key="img.id"
                      :src="img.url"
                  >
                    <!--                        @click="imageSelected(img.id)"-->
                  </v-carousel-item>

                </v-carousel>
                <v-carousel
                    height="300"
                    cycle
                    hide-delimiters
                    show-arrows-on-hover
                    v-else
                >
                  <v-carousel-item>
                    <v-img
                        height="400"
                        contain
                        src="https://firebasestorage.googleapis.com/v0/b/flexline-app.appspot.com/o/Logo%2FImage%20Placeholder.png?alt=media&token=b21de5eb-9239-4f64-a558-31d69e9d0726"
                    ></v-img>
                    <!--                        @click="imageSelected(img.id)"-->
                  </v-carousel-item>

                </v-carousel>

                <v-card-title style="word-break: break-word">
                  {{item.title}}
                </v-card-title>
                <v-card-subtitle>
                  <div class="subtitle-1 font-weight-regular">
                    <span v-if="item.itemType === 'service'">Starting from: </span>
                    ${{ item.baseRate}}</div>
                </v-card-subtitle>
                <v-card-text>
                  <v-row
                      align="center"
                      class="mx-0"
                  >
                    <div>{{item.shortDescription.substring(0,100)}}</div>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
          <!--    page description  section-->
        <v-layout  align-center justify-center>
          <v-flex v-if="listingDetails"  class="mt-6" xs12 sm12 md6 lg6>
            <div v-if="listingDetails.footerImages">
              <v-img
                  v-for="img in listingDetails.footerImages"
                  :key="img.id"
                  :src="img.url"
                  height="500px"
                  contain
              ></v-img>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    <v-dialog v-model="dialDialog"
              ref="dialog"
              persistent
              width="290px"
    >
      <v-card v-if="listingDetails">
        <v-card-title>
          <div class="white black--text text-xs-center font-weight-thin display-1">Let's connect!</div>
        </v-card-title>
        <v-card-text v-if="listingDetails">
          <div class="headline font-weight-light mt-3 mb-12">
            {{listingDetails.note}}
          </div>
          <div class="headline font-weight-bold">
            <v-icon large class="mr-1">smartphone</v-icon>
            Call or text
          </div>
          <div class="display-1 font-weight-light mb-3">
            {{listingDetails.listingContactNumber}}
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialDialog = false" text>cancel</v-btn>
          <v-btn @click="callNumber" class="blue" dark>Open Phone App</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="headerImageDialog"
              ref="dialog"
              persistent
              width="650px"
    >
      <v-container fluid fill-height>
        <v-layout row wrap justify-center>
          <v-flex xs12 sm12 md12 lg12
                  class="mt-4">
            <v-card v-if="selectedHeaderImage">
              <v-card-title>
                <v-btn @click="headerImageDialog = false" icon> <v-icon>cancel</v-icon></v-btn>
              </v-card-title>
              <v-card-text>
                <v-img
                    :src="selectedHeaderImage.url"
                    height="450px"
                    contain
                ></v-img>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-dialog>
  </v-container>
</template>

<script>
import {onSnapshot, getDoc, doc, collection} from "firebase/firestore";
import {getAuth, onAuthStateChanged} from "firebase/auth";
// import VueGtag from "vue-gtag"
// Vue.use(VueGtag, {
//   config: { id: "G-3H1BTW9FTV" }
// });
// import
export default {
  props:['publicListingId', 'listingId'],
  data: () => ({
    listingDetails: undefined,
    items: [],
    item: undefined,
    dialDialog: false,
    headerImageDialog: false,
    selectedHeaderImage: undefined

  }),
  computed: {
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  created() {
    const auth = getAuth()
    let db = this.$store.state.db

    onAuthStateChanged(auth, (user) => {
      if (user) {
        // console.log(user)
        if(!user.isAnonymous) {
          this.$store.dispatch('fetchUserData', user)
        } else {
          this.$store.dispatch('fetchAnonUserData', user)
        }
      } else {
        this.$store.dispatch('signupAnon')
      }
    })

    let itemsRef = collection(db, 'publicListings', this.publicListingId + '/listings/' + this.listingId + '/items')
    onSnapshot(itemsRef, res => {
      // console.log(res)
      if (res && res.empty !== true) {
        let items = []
        let sortedItems = []
        res.forEach(doc => {
          let data = doc.data()
          items.push(data)
        })
        // console.log(items)
        sortedItems = items.sort((a, b) => a.title.localeCompare(b.title))
        this.items = sortedItems
        this.$store.dispatch('setListingItems', sortedItems)
      }
      this.$store.dispatch('setLoading', false)
    })


    let publicItemRef = doc(db, 'publicListings', this.publicListingId + '/listings/' + this.listingId)
    return getDoc(publicItemRef)
        .then(res => {
          if (res.exists()) {
            let data = res.data()
            this.listingDetails = data
            this.$store.dispatch('setListingData', {...data, publicListingId: this.publicListingId, listingId: this.listingId})
            //console.log(this.listingDetails)
          }
        })
  },
  methods: {
    routeToImgRecog () {
      let route = '/imageQuote/' + this.publicListingId + '/'+ this.listingId
      this.$router.push(route)
    },
    routeToItem (item) {
      let link
      link = '/' + this.publicListingId + '/' + this.listingId + '/item/' + item.id
      this.$router.push(link)
      // console.log(item)
    },
    routeToOrder () {
      let link = '/' + this.listingsId + '/' + this.user.uid
      this.$router.push(link)
    },
    openHeaderImage (img) {
      this.selectedHeaderImage = img
      this.headerImageDialog = true
    },
    callNumber () {
      window.location.href = 'sms://' + this.listingDetails.listingContactNumber
      this.dialDialog = false
    }
  }
}
</script>

